'use strict';
import {ERROR_400, ERROR_500} from '../../core-utilities/react-i18n';

export function getCreateChildErrorMessage(status) {
  switch (status) {
    case 401:
      return 'project.child.create.permission.denied.message';

    case 400:
      return ERROR_400;

    case 500:
    default:
      return ERROR_500;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/utils/index.js